import { ACTIONS_TYPES } from "src/constants";

export const setCommonViewData = commonViewData => ({
  type: ACTIONS_TYPES.SET_WEB_COMMON_VIEW,
  payload: {
    commonViewData
  }
});

